export const usersRoute = [{
  path: 'users',
  component: () => import('../../../components/router-view'),
  children: [
    {
      path: '',
      name: 'UsersAdmin',
      component: () => import('../../../components/Admin/UsersAdmin.vue'),
      meta: {
        access: ['admin']
      }
    },
    {
      path: 'create',
      name: 'UserCreate',
      component: () => import('../../../components/Admin/CreateUser.vue'),
      meta: {
        access: ['admin']
      }
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/router/admin/module/usersRoute.js